import React from 'react';
import { BarStack } from '@vx/shape';
// import { Group } from '@vx/group';
import { AxisBottom } from '@vx/axis';
import { scaleBand, scaleLinear, scaleOrdinal } from '@vx/scale';
import { withTooltip, Tooltip } from '@vx/tooltip';
import { max } from 'd3-array';

import randomcolor from 'randomcolor';

const seed = 21;
const colors = [...randomcolor({
   count: 3,
   hue: '#a44afe',
   seed: seed
}), ...randomcolor({
   count: 3,
   hue: '#3be2b0',
   seed: seed
}), ...randomcolor({
   count: 3,
   hue: '#a44afe',
   seed: seed
}), ...randomcolor({
   count: 3,
   hue: '#3be2b0',
   seed: seed
})]

function FunnelChart({
  width,
  height,
  margin = {
    top: 40
  },
  steps,
  tooltipOpen,
  tooltipLeft,
  tooltipTop,
  tooltipData,
  hideTooltip,
  showTooltip
}) {
  if (width < 10) return null;

  const genColors = (number) => {
    let totalColors = colors;
    while (totalColors.length < number) {
      totalColors = [...totalColors].concat(colors);
    }
    return totalColors.slice(0, number);
  }
  // accessors
  const x = d => d.name;

  const totals = steps.map(d => d.value);

  // bounds
  const xMax = width;
  const yMax = height - margin.top - 40;

  // // scales
  const xScale = scaleBand({
    rangeRound: [0, xMax],
    domain: steps.map(x),
    padding: 0.2,
    tickFormat: () => val => val
  });
  const yScale = scaleLinear({
    rangeRound: [yMax, 0],
    nice: true,
    domain: [0, max(totals)*1.1]
  });
  const zScale = scaleOrdinal({
    domain: [1],
    range: genColors(steps.length)
  });

  let tooltipTimeout;

  return (
    <div style={{ position: 'relative' }}>
      <svg width={width} height={height}>
        <rect
          x={0}
          y={0}
          width={width}
          height={height}
          fill='#fff'
          rx={0}
        />
        <BarStack
          top={margin.top}
          data={steps}
          keys={['value']}
          height={yMax}
          x={x}
          xScale={xScale}
          yScale={yScale}
          zScale={zScale}
          onMouseLeave={data => event => {
            tooltipTimeout = setTimeout(() => {
              hideTooltip();
            }, 300);
          }}
          onMouseMove={data => event => {
            if (tooltipTimeout) clearTimeout(tooltipTimeout);
            const top = event.clientY - margin.top - 100;
            const left =
              xScale(data.x) + data.width + data.paddingInner * data.step / 2;
            showTooltip({
              tooltipData: data,
              tooltipTop: top,
              tooltipLeft: left
            });
          }}
        />
        <AxisBottom
          scale={xScale}
          top={yMax + margin.top}
          stroke="#a44afe"
          tickStroke="#a44afe"
          tickLabelProps={(value, index) => ({
            fill: '#676767',
            fontSize: 11,
            textAnchor: 'middle',
          })}
        />
      </svg>

      {tooltipOpen &&
        <Tooltip
          top={tooltipTop}
          left={tooltipLeft}
          style={{
            minWidth: 60,
            backgroundColor: 'rgba(255,255,255,0.9)',
            color: '#676767'
          }}
        >
          <div style={{ color: zScale(tooltipData.key) }}>
            <strong>
              {(tooltipData.data.convPercent||0)}%
            </strong>
          </div>
          <div>
            Total: {tooltipData.data[tooltipData.key]}
          </div>
          <div>
            <small>
              {tooltipData.xFormatted}
            </small>
          </div>
        </Tooltip>}
    </div>
  );
}

/*
<BarStack
  onClick={data => event => {
    if (!events) return;
    alert(`clicked: ${JSON.stringify(data)}`);
  }}
*/

export default withTooltip(FunnelChart);



// WEBPACK FOOTER //
// ./src/components/FunnelChart.js